export default "__VITE_ASSET__Belz1rUX__"